import { Component, OnInit, Inject } from '@angular/core';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { DlgTrabajandoComponent } from '../../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../../components/dlg-error/dlg-error.component';
import {MatDialogRef} from '@angular/material/dialog';
import { DlgAvisoComponent } from '../../components/dlg-aviso/dlg-aviso.component';
import { DlgBusquedasComponent } from '../../components/dlg-busquedas/dlg-busquedas.component';

@Component({
  selector: 'app-dlg-obras-sociales-prestacion',
  templateUrl: './dlg-obras-sociales-prestacion.component.html',
  styleUrls: ['./dlg-obras-sociales-prestacion.component.css']
})
export class DlgObrasSocialesPrestacionComponent implements OnInit {

  titulo="";
  idActual="";
  txtBusquedaPrestacion="";
  idPrestacion="";
  lblPrestacionActual="";
  txtCodigoPrestador="";
  txtNombrePrestador="";
  chkHabilitada=true;
  chkPorPresupuesto=false;
  tipoCoseguro="";
  txtImporteCoseguro="";
  txtImporteOS="";
  displayedColumnsPrestaciones

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private httpClient: HttpClient,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgObrasSocialesPrestacionComponent>,
  ) { }

  ngOnInit(): void {
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cerrar(cadena) {
    this.thisDialogRef.close({mensaje: cadena
      ,idPlanPrestacion: this.idActual
      ,idPrestacion: this.idPrestacion
      ,prestacionActual: this.lblPrestacionActual
      ,codigoPrestador:this.txtCodigoPrestador
      ,nombrePrestador:this.txtNombrePrestador
      ,habilitado: this.chkHabilitada
      ,porPresupuesto: this.chkPorPresupuesto
      ,tipoCoseguro: this.tipoCoseguro
      ,coseguro:this.txtImporteCoseguro
      ,importeOS: this.txtImporteOS
    });
  }

  buscarPrestacion(){
    let dlgBusquedas = this.dialog.open(DlgBusquedasComponent, {
      width: window.innerWidth.toString()+"px",
      disableClose:true
    });
    dlgBusquedas.componentInstance.lblTitBusqueda="Prestación:";
    dlgBusquedas.componentInstance.codBusqueda="PRESTACION";
    dlgBusquedas.componentInstance.txtBusc=this.txtBusquedaPrestacion;
    dlgBusquedas.afterClosed().subscribe(
      data => {
        if (data.idPrestacion!=null){
          this.idPrestacion=data.idPrestacion;
          this.lblPrestacionActual='(Cod.: '+data.codigo+') '+data.nombre;
          if (this.txtCodigoPrestador==""){
            this.txtCodigoPrestador=data.codigo;
          }
          if (this.txtNombrePrestador==""){
            this.txtNombrePrestador=data.nombre;
          }
        }
      }
    );
  }

  almacenar(){
    if (this.txtCodigoPrestador==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar el plan de la obra social";
      dlgError.componentInstance.texto="Le falto indicar el código de la prestación para el prestador";
      return;
    }
    if (this.txtNombrePrestador==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar el plan de la obra social";
      dlgError.componentInstance.texto="Le falto indicar el nombre de la prestación para el prestador";
      return;
    }
    if (!this.chkPorPresupuesto){
      if (this.tipoCoseguro==""){
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose:true
        });
        dlgError.componentInstance.titulo="Error al almacenar el plan de la obra social";
        dlgError.componentInstance.texto="Le falto indicar el tipo de coseguro";
        return;
      }
      if (this.txtImporteCoseguro==""){
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose:true
        });
        dlgError.componentInstance.titulo="Error al almacenar el plan de la obra social";
        dlgError.componentInstance.texto="Le falto indicar el importe de coseguro";
        return;
      }
      if (this.txtImporteOS==""){
        let dlgError = this.dialog.open(DlgErrorComponent, {
          width: '600px',
          disableClose:true
        });
        dlgError.componentInstance.titulo="Error al almacenar el plan de la obra social";
        dlgError.componentInstance.texto="Le falto indicar el importe de la obra social";
        return;
      }
    }
    this.cerrar('almaceno');
  }
}
